import { useState, useEffect, useRef, useMemo } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, Select, Table, ToggleSwitch, RadioButton, ProgressBar } from "@gpstrackit/react-controls";
import { Grid, Card, CardContent } from "@mui/material";
import CustomSelect from 'Components/Select';
import { NotificationManager } from "Components/Notifications";
import { HasPermission } from "Core/security"
import { copyToClipboard } from "Core/data/Helpers"

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';

import {
    bulkActionsSearchDevicesRequest,
    searchManufacturersRequest,
    bulkActionsSearchDeviceModelRequest,
    bulkActionsSearchDeviceModelResult,
    searchSimProvidersRequest,
    searchSimProviderAccountsRequest,
    bulkActionsSearchCommandsRequest,
    bulkActionsSendMessageRequest,
    bulkActionsRequest,
    searchEntityRequest,
    devicesImportGetDeviceModel,
    bulkActionsGetSupportedTimezonesRequest,
    clearRedux,
} from 'Redux/actions';

import './index.scss'

const BulkActions = (props) => {
    const { messages } = useIntl();
    const { principalTableRef } = props;
    const dispatch = useDispatch();
    const stepOne = useRef(null);
    const tableRef = useRef(null);
    const formRef = useRef(null);
    const navigate = useNavigate()

    const user = useSelector(state => state.securityRedux.user);

    const [step, setStep] = useState(1);

    const [account, setAccount] = useState(null);
    const [manufacturer, setManufacturer] = useState(null);
    const [deviceModel, setDeviceModel] = useState(null);
    const [simProvider, setSimProvider] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [conditions, setConditions] = useState({
        id: null,
        manufacturer: null,
        deviceModel: null,
        simProvider: null,
    });
    const [activeShow, setActiveShow] = useState(false);
    const [activeSimProvider, setActiveSimProvider] = useState(false);
    const [activePromiles, setActivePromiles] = useState(false);
    const [activeAnalytics, setActiveAnalytics] = useState(false);
    const [activeShowEcuSpeed, setActiveShowEcuSpeed] = useState(false);
    const [activeUseEcuOdometer, setActiveUseEcuOdometer] = useState(false);
    const [activeDeviceCategory, setActiveDeviceCategory] = useState(false);
    const [activeSendCommand, setActiveSendCommand] = useState(false);
    const [activeJbus, setActiveJbus] = useState(false);
    const [activeVbus, setActiveVbus] = useState(false);
    const [activeDriverBehavior, setActiveDriverBehavior] = useState(false);
    const [activeTimezone, setActiveTimezone] = useState(false);
    const [activeLinkedMode, setActiveLinkedMode] = useState(false);
    const [activeSendCalcOdometer, setActiveSendCalcOdometer] = useState(false);
    const [activeApu, setActiveApu] = useState(false);
    const [activeUseEcuVin, setActiveUseEcuVin] = useState(false);
    const [activeHybrid, setActiveHybrid] = useState(false);
    const [activeCariq, setActiveCariq] = useState(false);
    const [activeLiveMode, setActiveLiveMode] = useState(false);
    const [activeTags, setActiveTags] = useState(false);
    const [activeCarb, setActiveCarb] = useState(false);

    const [show, setShow] = useState(false);
    const [promiles, setPromiles] = useState(false);
    const [analytics, setAnalytics] = useState(false);
    const [showEcuSpeed, setShowEcuSpeed] = useState(false);
    const [useEcuOdometer, setUseEcuOdometer] = useState(false);
    const [deviceCategory, setDeviceCategory] = useState(false);
    const [vbus, setVbus] = useState(false);
    const [jbus, setJbus] = useState(false);
    const [driverBehavior, setDriverBehavior] = useState(false);
    const [sendCommandBy, setSendCommandBy] = useState("SMS");
    const [openCommand, setOpenCommand] = useState(false);
    const [commandSelections, setCommandSelections] = useState({});
    const [rawCommand, setRawCommand] = useState("");
    const [currentDeviceModel, setCurrentDeviceModel] = useState(null);
    const [newSimprovider, setNewSimprovider] = useState(null);
    const [simProviderAccountsList, setSimProviderAccounts] = useState([]);
    const [timezone, setTimezone] = useState(null);
    const [linkedMode, setLinkedMode] = useState(true);
    const [sendCalcOdometer, setSendCalcOdometer] = useState(false);
    const [apu, setApu] = useState(false);
    const [useEcuVin, setUseEcuVin] = useState(false);
    const [hybrid, setHybrid] = useState(false);
    const [cariq, setCariq] = useState(false);
    const [liveMode, setLiveMode] = useState("Streaming")
    const [selectedTags, setSelectedTags] = useState([]);
    const [carb, setCarb] = useState(false);

    const resetFeatures = () => {
        setActiveShow(false);
        setActiveSimProvider(false);
        setActivePromiles(false);
        setActiveAnalytics(false);
        setActiveShowEcuSpeed(false);
        setActiveUseEcuOdometer(false);
        setActiveDeviceCategory(false);
        setActiveSendCommand(false);
        setActiveJbus();
        setActiveVbus(false);
        setActiveDriverBehavior(false);
        setActiveTimezone(false);
        setActiveLinkedMode(false);
        setActiveSendCalcOdometer(false);
        setActiveApu(false);
        setActiveHybrid(false);
        setActiveUseEcuVin(false)
        setActiveCariq(false);
        setActiveLiveMode(false);
        setActiveTags(false);
        setActiveCarb(false);

        setShow(false);
        setPromiles(false);
        setAnalytics(false);
        setShowEcuSpeed(false);
        setUseEcuOdometer(false);
        setDeviceCategory(false);
        setVbus(false);
        setJbus(false);
        setDriverBehavior(false);
        setSendCommandBy("SMS");
        setOpenCommand(false);
        setCommandSelections({});
        setRawCommand("");
        setCurrentDeviceModel(null);
        setNewSimprovider(null);
        setTimezone(null);
        setLinkedMode(true);
        setSendCalcOdometer(false);
        setApu(false);
        setHybrid(false);
        setUseEcuVin(false);
        setCariq(false);
        setLiveMode("Streaming")
        setSelectedTags([]);
        setCarb(false);
    }

    const {
        devices,
        devicesLoading,
        result,
        openModal,
        devicesModels,
        devicesModelsLoading,
        loading,
        commands,
        commandsLoading,
        sendCommandLoading,
        sendCommand,
        bulkFeatures,
        supportedTimezones
    } = useSelector(state => state.bulkActionsRedux);

    const deviceCounters = useMemo(() => {
        const unitTypes = {};
        const deviceModels = {};

        selectedItems.forEach((device) => {
            const model = device?.deviceModel;
            if (!model) {
                return;
            }

            if (model.unitTypeId) {
                if (!unitTypes[model.unitTypeId]) {
                    unitTypes[model.unitTypeId] = {
                        id: model.unitTypeId,
                        name: model.unitType?.name || `Unit Type #${model.unitTypeId}`,
                        count: 0
                    };
                }
                unitTypes[model.unitTypeId].count += 1;
            }

            if (model.id) {
                if (!deviceModels[model.id]) {
                    deviceModels[model.id] = {
                        id: model.id,
                        name: model.name || `Device Model #${model.id}`,
                        unitTypeId: model.unitTypeId,
                        count: 0
                    };
                }
                deviceModels[model.id].count += 1;
            }
        });

        return {
            unitTypes: Object.values(unitTypes),
            deviceModels: Object.values(deviceModels)
        };
    }, [selectedItems]);

    const commandGroups = useMemo(() => {
        const resultGroups = [];
        const commandData = commands || {};

        if (commandData?.manufacturer?.cannedCommands?.length) {
            resultGroups.push({
                key: `manufacturer-${commandData.manufacturer.entityId}`,
                entity: "Manufacturer",
                entityId: commandData.manufacturer.entityId,
                entityLabel: commandData.manufacturer.entityLabel,
                cannedCommands: commandData.manufacturer.cannedCommands,
                deviceCount: selectedItems.length,
                deviceIds: selectedItems.map(item => item.id)
            });
        }

        (commandData?.unitTypes || []).forEach((unitTypeGroup) => {
            const currentCounter = deviceCounters.unitTypes.find(item => item.id === unitTypeGroup.entityId);
            if (!unitTypeGroup?.cannedCommands?.length || !currentCounter?.count) {
                return;
            }

            resultGroups.push({
                key: `unittype-${unitTypeGroup.entityId}`,
                entity: "UnitType",
                entityId: unitTypeGroup.entityId,
                entityLabel: unitTypeGroup.entityLabel || currentCounter.name,
                cannedCommands: unitTypeGroup.cannedCommands,
                deviceCount: currentCounter.count,
                deviceIds: selectedItems
                    .filter(item => item?.deviceModel?.unitTypeId === unitTypeGroup.entityId)
                    .map(item => item.id)
            });
        });

        (commandData?.deviceModels || []).forEach((deviceModelGroup) => {
            const currentCounter = deviceCounters.deviceModels.find(item => item.id === deviceModelGroup.entityId);
            if (!deviceModelGroup?.cannedCommands?.length || !currentCounter?.count) {
                return;
            }

            resultGroups.push({
                key: `devicemodel-${deviceModelGroup.entityId}`,
                entity: "DeviceModel",
                entityId: deviceModelGroup.entityId,
                entityLabel: deviceModelGroup.entityLabel || currentCounter.name,
                cannedCommands: deviceModelGroup.cannedCommands,
                deviceCount: currentCounter.count,
                deviceIds: selectedItems
                    .filter(item => item?.deviceModel?.id === deviceModelGroup.entityId)
                    .map(item => item.id)
            });
        });

        return resultGroups;
    }, [commands, deviceCounters, selectedItems]);

    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux);
    const { manufacturers, simProviderAccounts, timeZones, deviceModels, tags } = useSelector(state => state.generalRedux);
    const loadingTags = useSelector(state => state.generalRedux.loadingEntity);
    const devModel = useSelector(state => state.importDevicesRedux.deviceModel);
    const loadingDM = useSelector(state => state.importDevicesRedux.loading);

    const closeModal = () => {
        dispatch(clearRedux("BULK_ACTIONS"));
        dispatch(clearRedux("IMPORT_DEVICES"));
        setSimProviderAccounts([]);
        resetFeatures();
    }

    const accountHandler = (newaccount) => {
        setAccount(newaccount);
        setTimezone(newaccount?.timezoneId)
        let currentConditions = conditions;
        currentConditions.id = newaccount?.id;
        setConditions(currentConditions);
        newaccount && dispatch(bulkActionsSearchDevicesRequest(currentConditions));
        !newaccount && dispatch(clearRedux("BULK_ACTIONS", { devices: [] }));
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    const applyChanges = () => {
        let unitIds = selectedItems.map((item) => (item?.id))
        let payload = {
            features: {},
            unitIds
        }
        if (activeSimProvider && !newSimprovider?.id) {
            NotificationManager.error(
                messages['devices_bulk_you_must_select_a_sim_provider_account'],
                messages['devices_bulk_actions_title'],
                3000
            );
            return
        }
        if (activeSimProvider && newSimprovider?.id) {
            payload.simProviderAccountId = newSimprovider?.id;
        }
        if (activeTimezone) {
            payload.timezoneId = timezone
        }
        if (activeShow) {
            payload.features.show = show;
        }

        if (activePromiles && currentDeviceModel?.promiles) {
            payload.features.promiles = promiles
        }
        if (activeAnalytics && currentDeviceModel?.analytic) {
            payload.features.analytics = analytics
        }
        if (activeShowEcuSpeed && currentDeviceModel?.odometerEnable) {
            payload.features.useEcuSpeed = showEcuSpeed
        }
        if (activeUseEcuOdometer && currentDeviceModel?.odometerEnable) {
            payload.features.useEcuOdometer = useEcuOdometer
        }
        if (activeDeviceCategory) {
            payload.features.deviceCategory = !deviceCategory ? "Fleet" : "Asset"
        }
        if (activeVbus && currentDeviceModel?.vbus) {
            payload.features.vbus = vbus;
        }
        if (activeJbus && currentDeviceModel?.jbus) {
            payload.features.jbus = jbus;
        }
        if (activeDriverBehavior && currentDeviceModel?.driverBehavior) {
            payload.features.driverBehavior = driverBehavior;
        }
        if (activeSendCalcOdometer && currentDeviceModel?.promiles && currentDeviceModel?.promilesOdometerCalculated) {
            payload.features.promilesOdometerCalculated = sendCalcOdometer;
        }
        if (activeApu) {
            payload.features.apu = apu;
        }
        if (activeHybrid) {
            payload.features.hybrid = hybrid;
        }
        if (activeUseEcuVin && currentDeviceModel?.odometerEnable) {
            payload.features.useEcuVin = useEcuVin;
        }
        if (activeLinkedMode) {
            payload.features.linkedMode = linkedMode;
        }
        if (activeLiveMode) {
            payload.liveMode = liveMode;
        }

        if (activeTags) {
            payload.tagIds = selectedTags
        }

        if (activeSendCommand && currentDeviceModel?.manufacturer?.name?.toUpperCase() !== "VIDFLEET") {
            const entityName = sendCommandBy === "SMS" ? "SmsCommand" : "OtaCommand";

            if (openCommand) {
                const payloadCommands = {
                    command: rawCommand,
                    to: [{ entityName, entityIds: selectedItems.map(device => device?.id).filter(Boolean) }]
                };
                dispatch(bulkActionsSendMessageRequest(payloadCommands));
            } else {
                const groupsWithDevices = commandGroups.filter(group => group.deviceIds.length > 0);
                const missingSelections = groupsWithDevices.filter(group => !commandSelections[group.key]);

                if (missingSelections.length > 0) {
                    NotificationManager.warning(
                        messages['devices_bulk_select_command_for_each_group'],
                        messages['devices_bulk_actions_title'],
                        3000
                    );
                    return;
                }

                const commandRequests = groupsWithDevices.map((group) => ({
                    command: commandSelections[group.key]?.command,
                    to: [{ entityName, entityIds: group.deviceIds }]
                }));

                if (commandRequests.length > 0) {
                    dispatch(bulkActionsSendMessageRequest(commandRequests));
                }
            }
        }
        if (activeCariq && currentDeviceModel?.cariq) {
            payload.features.cariq = cariq;
        }

        if (activeCarb && currentDeviceModel?.carbEnable) {
            payload.features.carb = carb;
        }

        let featureValidation = activeSimProvider || activeTimezone || activePromiles || activeAnalytics || activeShowEcuSpeed || activeUseEcuOdometer || activeDeviceCategory || activeVbus || activeJbus || activeDriverBehavior || activeSendCalcOdometer || activeApu || activeHybrid || activeUseEcuVin || activeShow || activeCariq || activeLinkedMode || activeLiveMode || activeTags || activeCarb
        if (featureValidation) dispatch(bulkActionsRequest(payload));

        if (!activeSendCommand && !featureValidation) {
            NotificationManager.warning(
                messages['devices_bulk_you_must_apply_some_changes'],
                messages['devices_bulk_actions_title'],
                3000
            );
        }


    }

    const handleSteps = () => {
        if (step === 1) {
            stepOne?.current?.submit();
        }
        if (step === 2) {
            if (selectedItems.length > 0) {
                let deviceModel = !bulkFeatures ? selectedItems[0]?.deviceModel : devModel;
                const firstManufacturerId = selectedItems[0]?.deviceModel?.manufacturerId;
                const firstManufacturerName = selectedItems[0]?.deviceModel?.manufacturer?.name;
                const unitTypeIds = [...new Set(selectedItems.map(item => item?.deviceModel?.unitTypeId).filter(Boolean))];
                const deviceModelsPayload = [...new Map(
                    selectedItems
                        .filter(item => item?.deviceModel?.id)
                        .map(item => [item.deviceModel.id, {
                            id: item.deviceModel.id,
                            name: item.deviceModel.name,
                            unitTypeId: item.deviceModel.unitTypeId
                        }])
                ).values()];

                setCommandSelections({});
                dispatch(bulkActionsSearchCommandsRequest({
                    manufacturerId: firstManufacturerId,
                    manufacturerName: firstManufacturerName,
                    unitTypeIds,
                    deviceModelIds: deviceModelsPayload.map(item => item.id),
                    deviceModels: deviceModelsPayload,
                    via: sendCommandBy
                }));
                setCurrentDeviceModel(!bulkFeatures ? deviceModel : devModel)
                setStep(3);
            }
            else {
                NotificationManager.warning(
                    messages['devices_bulk_you_have_no_devices_selected'],
                    messages['devices_bulk_actions_title'],
                    3000
                );
            }
        }
    }

    useEffect(() => {
        if (openModal) {
            dispatch(searchManufacturersRequest());
            dispatch(searchSimProvidersRequest());
            dispatch(searchSimProviderAccountsRequest());
        }
    }, [openModal])

    useEffect(() => {
        if (simProviderAccounts && simProviderAccounts.length > 0) {
            let current = simProviderAccounts.map((item) => ({ ...item, label: `${item.name} ${item?.simProvider?.name ? `- ${item?.simProvider?.name}` : ""}` }));
            setSimProviderAccounts(current);
        }
    }, [simProviderAccounts])

    useEffect(() => {
        if (result) {
            if (result?.updateFeatures) {
                let transactionId = result?.updateFeatures?.transactionId;
                let message = messages["devices_bulk_actions_message"]
                NotificationManager.success(message, messages['devices_bulk_actions_title'], 10000, () => {
                    copyToClipboard(transactionId, messages['common_copied']);
                    navigate(`/app/transactions/list/${transactionId}`);

                }, null, '', null);

                principalTableRef && principalTableRef.current?.getData();
                closeModal();
            } else {
                NotificationManager.error(
                    messages['devices_bulk_it_was_not_possible_to_update_the_features'],
                    messages['devices_bulk_actions_title'],
                    3000
                );
                dispatch(clearRedux("BULK_ACTIONS", { result: null }));
            }
        }
        if (sendCommand) {
            let featureValidation = activeSimProvider || activePromiles || activeAnalytics || activeShowEcuSpeed || activeUseEcuOdometer || activeDeviceCategory || activeVbus || activeJbus || activeDriverBehavior
            if (!featureValidation && activeSendCommand && currentDeviceModel?.manufacturer?.name?.toUpperCase() !== "VIDFLEET") {
                if (sendCommand?.success || sendCommand === true) {
                    NotificationManager.success(
                        messages['devices_bulk_the_command_has_been_sent'],
                        messages['devices_bulk_actions_title'],
                        3000
                    );
                    closeModal();
                } else {
                    NotificationManager.error(
                        messages['devices_bulk_an_error_occurred_while_sending_the_command'],
                        messages['devices_bulk_actions_title'],
                        3000
                    );
                    dispatch(clearRedux("BULK_ACTIONS", { sendCommand: null }));
                }
            }
        }
    }, [result, sendCommand])

    useEffect(() => {
        if (step === 2) {
            tableRef && selectedItems.length > 0 && !bulkFeatures && tableRef.current?.setSelectedItems(selectedItems)
        }
    }, [step]);

    useEffect(() => {
        if (step === 3 && selectedItems.length > 0) {
            const firstManufacturerId = selectedItems[0]?.deviceModel?.manufacturerId;
            const firstManufacturerName = selectedItems[0]?.deviceModel?.manufacturer?.name;
            const unitTypeIds = [...new Set(selectedItems.map(item => item?.deviceModel?.unitTypeId).filter(Boolean))];
            const deviceModelsPayload = [...new Map(
                selectedItems
                    .filter(item => item?.deviceModel?.id)
                    .map(item => [item.deviceModel.id, {
                        id: item.deviceModel.id,
                        name: item.deviceModel.name,
                        unitTypeId: item.deviceModel.unitTypeId
                    }])
            ).values()];

            setCommandSelections({});
            dispatch(bulkActionsSearchCommandsRequest({
                manufacturerId: firstManufacturerId,
                manufacturerName: firstManufacturerName,
                unitTypeIds,
                deviceModelIds: deviceModelsPayload.map(item => item.id),
                deviceModels: deviceModelsPayload,
                via: sendCommandBy
            }));
        }
    }, [sendCommandBy]);

    useEffect(() => {
        if (bulkFeatures) {
            setStep(2);
            dispatch(devicesImportGetDeviceModel(devices[0]?.deviceModel?.id));
        }
    }, [bulkFeatures]);

    useEffect(() => {
        if (devModel) {
            tableRef && devices.length > 0 && tableRef.current?.setSelectedItems(devices);

            setCurrentDeviceModel(devModel)
            setSelectedItems(devices)
        }
    }, [devModel]);

    useEffect(() => {
        (!timeZones || timeZones.length === 0) && dispatch(searchEntityRequest({ key: "timezones" }));
        (!supportedTimezones || supportedTimezones.length === 0) && dispatch(bulkActionsGetSupportedTimezonesRequest());
        (!deviceModels || deviceModels.length === 0) && dispatch(searchEntityRequest({ key: "deviceModels" }));
        (!manufacturers || manufacturers.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }));
        dispatch(searchEntityRequest({ key: "tags" }));
    }, []);

    let innerHeight = window.innerHeight;
    let isVidfleet = currentDeviceModel?.manufacturer?.name?.toUpperCase() === "VIDFLEET";
    let isSmartWitness = currentDeviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS";
    let isGlobalStar = currentDeviceModel?.manufacturer?.name?.toUpperCase() === "GLOBAL STAR";

    let selectedTimezone = timeZones.find(x => x.id === timezone)
    let supportedTimezone = selectedTimezone ? supportedTimezones.find(x => x.id === selectedTimezone.name) ? true : false : false
    let found = devices.find(x => x.linkedMode || x.linkedByUnit?.id)
    let showTzMsg = found ? true : false

    if (found?.linkedByUnit?.id) {
        let devModel = deviceModels.find(x => x.id === found?.linkedByUnit.deviceModelId)
        let manufacurer = null
        if (devModel)
            manufacurer = manufacturers.find(x => x.id === devModel.manufacturerId)
        if (manufacurer?.name?.toLowerCase() !== "vidfleet") {
            showTzMsg = false
        }
    }

    let alertMsg = ""
    if (showTzMsg) {
        if (supportedTimezone) {
            alertMsg = found?.linkedMode ? messages['feature_tab_tz_to_gps'] : found?.linkedByUnit?.id ? messages['feature_tab_tz_to_camera'] : ""
        } else
            alertMsg = messages['feature_tab_tz_not_supported']
    }

    return (
        <Modal
            open={openModal}
            title={!bulkFeatures ? messages['devices_bulk_actions_title'] : messages['devices_bulk_features']}
            handleClose={() => closeModal()}
            position="right"
            loading={devicesLoading || loading || sendCommandLoading || loadingDM}
        >
            <ModalBody style={{ height: step === 1 && '70%' }}>
                <div style={{ width: '100%' }}>
                    <ProgressBar steps={3} activeStep={step} />
                </div>
                <div style={{ padding: '0 10px', paddingBottom: 20 }}>
                    {
                        step === 1 &&
                        <Form
                            ref={stepOne}
                            onValidSubmit={() => {
                                if (!account?.id) {
                                    NotificationManager.warning(
                                        messages['devices_bulk_it_is_necessary_to_select_an_account'],
                                        messages['devices_bulk_actions_title'],
                                        3000
                                    );
                                } else setStep(2);
                            }}
                        >
                            <CustomSelect
                                async
                                value={account}
                                onChange={(items) => accountHandler(items)}
                                label={messages['devices_bulk_actions_account']}
                                loadOptions={getAccountsForSelect}
                                loading={loadingAccounts}
                                required
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}
                            />
                        </Form>
                    }
                    {
                        step === 2 &&
                        <Grid container spacing={2}>
                            {
                                !bulkFeatures &&
                                <Grid item xs={4}>
                                    <Select
                                        id="manufacturer-list"
                                        value={manufacturer}
                                        placeholder={messages['devices_bulk_actions_manufacturer']}
                                        options={manufacturers}
                                        onChange={(e) => {
                                            let currentConditions = conditions;
                                            setManufacturer(e);
                                            if (e?.id) {
                                                currentConditions.manufacturer = e.id;
                                                dispatch(bulkActionsSearchDeviceModelRequest(e.name))
                                            }
                                            else {
                                                currentConditions.manufacturer = null;
                                                dispatch(bulkActionsSearchDeviceModelResult([]))
                                            }
                                            dispatch(bulkActionsSearchDevicesRequest(currentConditions));
                                            setConditions(currentConditions)
                                            setDeviceModel(null);
                                            setSelectedItems([]);
                                            tableRef.current?.setSelectedItems([]);

                                        }}
                                        isClearable
                                        valueField="id"
                                        textField="name"
                                    />
                                </Grid>
                            }
                            {
                                !bulkFeatures &&
                                <Grid item xs={4}>
                                    <div className="bulk-action-selector">
                                        <Select
                                            id="device-model-list"
                                            value={deviceModel}
                                            placeholder={messages['devices_bulk_actions_device_model']}
                                            options={devicesModels}
                                            loading={devicesModelsLoading}
                                            onChange={(e) => {
                                                let currentConditions = conditions;
                                                currentConditions.deviceModel = e?.id;
                                                setConditions(currentConditions);
                                                dispatch(bulkActionsSearchDevicesRequest(currentConditions));
                                                setDeviceModel(e);
                                                setSelectedItems([]);
                                                tableRef.current?.setSelectedItems([]);
                                            }}
                                            isClearable
                                            valueField="id"
                                            textField="name"
                                        />
                                    </div>
                                </Grid>
                            }
                            {
                                !bulkFeatures &&
                                <Grid item xs={4}>
                                    <Select
                                        id="sim-provider-list"
                                        value={simProvider}
                                        placeholder={messages['devices_bulk_sim_provider_account']}
                                        options={simProviderAccountsList}
                                        onChange={(e) => {
                                            let currentConditions = conditions;
                                            currentConditions.simProvider = e?.id;
                                            setConditions(currentConditions);
                                            dispatch(bulkActionsSearchDevicesRequest(currentConditions));
                                            setSimProvider(e);
                                            setSelectedItems([]);
                                            tableRef.current?.setSelectedItems([]);
                                        }}
                                        isClearable
                                        valueField="id"
                                        textField="label"
                                    />
                                </Grid>
                            }
                            <Grid item xs={12} style={{ width: '100%' }}>
                                <Table
                                    ref={tableRef}
                                    onSelectedItems={(items) => setSelectedItems(items)}
                                    columns={[
                                        {
                                            key: "manufacturer",
                                            title: messages['devices_bulk_actions_manufacturer'],
                                            width: 150,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span>{item?.deviceModel?.manufacturer?.name}</span>
                                                )
                                            }
                                        },
                                        {
                                            key: "devicemodel",
                                            title: messages['devices_bulk_actions_device_model'],
                                            width: 200,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span>{item?.deviceModel?.name}</span>
                                                )
                                            }
                                        },
                                        {
                                            key: "devicename",
                                            title: messages['devices_bulk_actions_device_name'],
                                            width: 200,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span>{item?.label}</span>
                                                )
                                            }
                                        },
                                        {
                                            key: "simprovideraccount",
                                            title: messages['devices_bulk_sim_provider_account'],
                                            width: 250,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span>
                                                        {`${item?.simCard?.simProviderAccount?.name} - ${item?.simCard?.simProviderAccount?.simProvider?.name || ''}`}
                                                    </span>
                                                )
                                            }
                                        },
                                        {
                                            key: "imei",
                                            title: messages['devices_bulk_actions_imei'],
                                            width: 300,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span>{item.imei}</span>
                                                )
                                            }
                                        },
                                        {
                                            key: "serial",
                                            title: messages['devices_bulk_actions_serial'],
                                            width: 200,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <span>{item?.esn}</span>
                                                )
                                            }
                                        },
                                        {
                                            key: "script",
                                            title: messages['devices_bulk_actions_script'],
                                            width: 200,
                                            show: true,
                                            sort: false,
                                            locked: false,
                                            resize: false,
                                            render: (item) => {
                                                return (
                                                    <>
                                                        {
                                                            item?.unitConfig?.scriptVersion && item?.unitConfig?.configVersion
                                                                ? <span>{`${item?.unitConfig?.scriptVersion}.${item?.unitConfig?.configVersion}`}</span>
                                                                : <span>{item?.unitConfig?.scriptVersion}</span>
                                                        }
                                                    </>

                                                )
                                            }
                                        },
                                    ]}
                                    data={devices}
                                    height={innerHeight - 280}
                                    infiniteScroll
                                />
                            </Grid>
                        </Grid>
                    }
                    {
                        step === 3 &&
                        <Form
                            ref={formRef}
                            onValidSubmit={() => applyChanges()}
                        >
                            <Grid container spacing={2} style={{ padding: '25px 10px' }}>
                                <Grid item xs={12}>
                                    <p style={{ marginTop: 5 }}>{selectedItems.length} {messages['devices_bulk_actions_devices_will_be_affected']}</p>
                                </Grid>
                                {
                                    !isVidfleet && !isSmartWitness &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_send_command']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-send-command"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeSendCommand}
                                                                onChange={(checked) => setActiveSendCommand(checked)}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeSendCommand &&
                                                        <Grid item xs={12} style={{ marginTop: 10 }}>
                                                            <Grid container>
                                                                <Grid item xs={12}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <label className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1" style={{ marginRight: 5 }}>{messages['devices_bulk_send_command_via']}</label>
                                                                        <RadioButton
                                                                            onChange={() => {
                                                                                setSendCommandBy('SMS')
                                                                                setCommandSelections({})
                                                                            }}
                                                                            value={sendCommandBy === 'SMS'}
                                                                            label={messages['devices_bulk_actions_sms']}
                                                                            position="end"
                                                                        />
                                                                        <RadioButton
                                                                            onChange={() => {
                                                                                setSendCommandBy('OTA')
                                                                                setCommandSelections({})
                                                                            }}
                                                                            value={sendCommandBy === 'OTA'}
                                                                            label={messages['devices_bulk_actions_ota']}
                                                                            position="end"
                                                                        />
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <div style={{ display: 'grid' }}>
                                                                        <label className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1" style={{ marginRight: 5, marginBottom: 10 }}>{messages['devices_bulk_actions_open_command']}</label>
                                                                        <ToggleSwitch
                                                                            id="toogle-open-command"
                                                                            large
                                                                            blueToggle
                                                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                                                            checked={openCommand}
                                                                            onChange={(checked) => {
                                                                                setOpenCommand(checked)
                                                                                if (!checked) setRawCommand("");
                                                                                if (checked) setCommandSelections({});
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    {
                                                                        !openCommand &&
                                                                        <div style={{ marginTop: 10, marginBottom: 20 }}>
                                                                            <div className="command-counters-wrapper">
                                                                                {
                                                                                    deviceCounters.unitTypes.map((unitType) => (
                                                                                        <div className="command-counter" key={`counter-ut-${unitType.id}`}>
                                                                                            <strong>{messages['devices_bulk_unit_type']}:</strong> {unitType.name} ({unitType.count})
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                                {
                                                                                    deviceCounters.deviceModels.map((deviceModelCounter) => (
                                                                                        <div className="command-counter" key={`counter-dm-${deviceModelCounter.id}`}>
                                                                                            <strong>{messages['devices_bulk_actions_device_model']}:</strong> {deviceModelCounter.name} ({deviceModelCounter.count})
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                            {
                                                                                commandGroups.map((group) => (
                                                                                    <div className="group-command-selector" key={group.key}>
                                                                                        <label className="group-command-label">
                                                                                            {messages['devices_bulk_command_entity_label'].replace('{entity}', group.entity).replace('{name}', group.entityLabel || group.entity)}
                                                                                        </label>
                                                                                        <span className="group-command-count">
                                                                                            {messages['devices_bulk_devices_count'].replace('{count}', group.deviceCount)}
                                                                                        </span>
                                                                                        <Select
                                                                                            id={`command-list-${group.key}`}
                                                                                            value={commandSelections[group.key] || null}
                                                                                            valueField="id"
                                                                                            textField="label"
                                                                                            options={group.cannedCommands || []}
                                                                                            placeholder={messages['devices_bulk_actions_command']}
                                                                                            onChange={(value) => setCommandSelections(prev => ({ ...prev, [group.key]: value }))}
                                                                                            loading={commandsLoading}
                                                                                            required
                                                                                            requiredMessage={messages['required_field']}
                                                                                        />
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                            {
                                                                                !commandsLoading && commandGroups.length === 0 &&
                                                                                <div className="group-command-empty">{messages['devices_bulk_no_commands_available']}</div>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        openCommand &&
                                                                        <div style={{ marginTop: 10, marginBottom: 20 }} className="raw-command-container">
                                                                            <Input
                                                                                label={messages['devices_bulk_actions_raw_command']}
                                                                                value={rawCommand}
                                                                                type="textarea"
                                                                                style={{ width: '100%', height: 500 }}
                                                                                onChange={(value) => setRawCommand(value)}
                                                                                required
                                                                                requiredMessage={messages['required_field']}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    !isGlobalStar &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', height: 47, marginBottom: activeSimProvider ? 15 : 6 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_sim_provider_account']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-sim-provider"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeSimProvider}
                                                                onChange={(checked) => {
                                                                    setActiveSimProvider(checked)
                                                                    if (!checked) setNewSimprovider(null)
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeSimProvider &&
                                                        <Grid item xs={6} style={{ marginTop: 5 }}>
                                                            <Select
                                                                id="new-sim-provider"
                                                                value={newSimprovider}
                                                                options={simProviderAccountsList}
                                                                placeholder={messages['devices_bulk_sim_provider_account']}
                                                                valueField="id"
                                                                textField="label"
                                                                onChange={(value) => setNewSimprovider(value)}
                                                                required
                                                                requiredMessage={messages['required_field']}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }

                                <Grid item xs={12}>
                                    <Card>
                                        <CardContent>
                                            <Grid container style={{ width: '100%', display: 'flex', height: 47, marginBottom: activeTimezone ? 15 : 6 }}>
                                                <Grid item xs={5}>
                                                    <div>
                                                        <label style={{ marginBottom: 5 }}>{messages['devices_bulk_sim_timezone']}</label>
                                                        <ToggleSwitch
                                                            id="toogle-time-zone"
                                                            large
                                                            blueToggle
                                                            optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                            checked={activeTimezone}
                                                            onChange={(checked) => {
                                                                setActiveTimezone(checked)
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                                {
                                                    activeTimezone &&
                                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                                        <Select
                                                            id="timezones"
                                                            placeholder={messages['feature_tab_timezone']}
                                                            options={timeZones || []}
                                                            value={timezone ? timeZones.find(x => x.id === timezone) : null}
                                                            textField="name"
                                                            valueField="id"
                                                            onChange={(timezone) => {
                                                                setTimezone(timezone?.id)
                                                            }}
                                                            required
                                                            requiredMessage={messages['required_field']}
                                                        />
                                                        {
                                                            showTzMsg &&
                                                            <label className="input-normal-label" style={{ marginRight: 5, color: 'red' }}>{alertMsg}</label>
                                                        }
                                                    </Grid>
                                                }
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_show']}</label>
                                                        <div>
                                                            <ToggleSwitch
                                                                id="toogle-show"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeShow}
                                                                onChange={(checked) => {
                                                                    setActiveShow(checked)
                                                                    if (!checked) setShow(false)
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeShow &&
                                                        <Grid item xs={4} style={{ margin: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-show-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={show}
                                                                onChange={(checked) => setShow(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.promiles &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_promiles']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-promiles"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activePromiles}
                                                                onChange={(checked) => {
                                                                    setActivePromiles(checked)
                                                                    if (!checked) setPromiles(false)
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activePromiles &&
                                                        <Grid item xs={4} style={{ margin: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-sim-promise"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={promiles}
                                                                onChange={(checked) => setPromiles(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.driverBehavior &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_driver_behavior']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-driverBehavior"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeDriverBehavior}
                                                                onChange={(checked) => {
                                                                    setActiveDriverBehavior(checked);
                                                                    if (!checked) setDriverBehavior(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeDriverBehavior &&
                                                        <Grid item xs={4} style={{ margin: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-driverBehavior-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={driverBehavior}
                                                                onChange={(checked) => setDriverBehavior(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.analytic &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_analytics']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-analytics"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeAnalytics}
                                                                onChange={(checked) => {
                                                                    setActiveAnalytics(checked);
                                                                    if (!checked) setAnalytics(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeAnalytics &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-analytics-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={analytics}
                                                                onChange={(checked) => setAnalytics(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.vbus &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>VBus</label>
                                                            <ToggleSwitch
                                                                id="toogle-vbus"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeVbus}
                                                                onChange={(checked) => {
                                                                    setActiveVbus(checked);
                                                                    if (!checked)
                                                                        setVbus(false);
                                                                    else {
                                                                        setActiveJbus(false)
                                                                        setJbus(false)
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeVbus &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-vbus-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={vbus}
                                                                onChange={(checked) => setVbus(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.jbus &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <label style={{ marginBottom: 5 }}>JBus</label>
                                                        <div>
                                                            <ToggleSwitch
                                                                id="toogle-jbus"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeJbus}
                                                                onChange={(checked) => {
                                                                    setActiveJbus(checked);
                                                                    if (!checked)
                                                                        setJbus(false);
                                                                    else {
                                                                        setActiveVbus(false)
                                                                        setVbus(false)
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeJbus &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-jbus-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={jbus}
                                                                onChange={(checked) => setJbus(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.odometerEnable &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_show_ecu_speed']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-show-edu-speed"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeShowEcuSpeed}
                                                                onChange={(checked) => {
                                                                    setActiveShowEcuSpeed(checked)
                                                                    if (!checked) setShowEcuSpeed(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeShowEcuSpeed &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-show-edu-speed-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={showEcuSpeed}
                                                                onChange={(checked) => setShowEcuSpeed(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.odometerEnable &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_use_ecu_odometer']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-use-edu-odometer"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeUseEcuOdometer}
                                                                onChange={(checked) => {
                                                                    setActiveUseEcuOdometer(checked)
                                                                    if (!checked) setUseEcuOdometer(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeUseEcuOdometer &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-use-edu-odometer-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={useEcuOdometer}
                                                                onChange={(checked) => setUseEcuOdometer(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.odometerEnable && currentDeviceModel?.promiles &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_send_calc_odometer']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-send-calc-odometer"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeSendCalcOdometer}
                                                                onChange={(checked) => {
                                                                    setActiveSendCalcOdometer(checked)
                                                                    if (!checked) setSendCalcOdometer(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeSendCalcOdometer &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-send-calc-odometer-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={sendCalcOdometer}
                                                                onChange={(checked) => setSendCalcOdometer(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }

                                {

                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_apu']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-apu"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeApu}
                                                                onChange={(checked) => {
                                                                    setActiveApu(checked)
                                                                    if (!checked) setApu(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeApu &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-apu-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={apu}
                                                                onChange={(checked) => setApu(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {

                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_hybrid']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-hybrid"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeHybrid}
                                                                onChange={(checked) => {
                                                                    setActiveHybrid(checked)
                                                                    if (!checked) setHybrid(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeHybrid &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-hybrid-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={hybrid}
                                                                onChange={(checked) => setHybrid(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.odometerEnable &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_use_ecu_vin']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-useEcuVin"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeUseEcuVin}
                                                                onChange={(checked) => {
                                                                    setActiveUseEcuVin(checked)
                                                                    if (!checked) setUseEcuVin(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeUseEcuVin &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-useEcuVin-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={useEcuVin}
                                                                onChange={(checked) => setUseEcuVin(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                <Grid item xs={12}>
                                    <Card>
                                        <CardContent>
                                            <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                <Grid item xs={5}>
                                                    <div>
                                                        <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_device_category']}</label>
                                                        <ToggleSwitch
                                                            id="toogle-device-category"
                                                            large
                                                            blueToggle
                                                            optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                            checked={activeDeviceCategory}
                                                            onChange={(checked) => {
                                                                setActiveDeviceCategory(checked)
                                                                if (!checked) setDeviceCategory(false)
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                                {
                                                    activeDeviceCategory &&
                                                    <Grid item xs={4} style={{ marginTop: 10 }}>
                                                        <ToggleSwitch
                                                            id="toogle-device-category-value"
                                                            large
                                                            blueToggle
                                                            optionLabels={[messages['devices_bulk_actions_asset'], messages['devices_bulk_actions_fleet']]}
                                                            checked={deviceCategory}
                                                            onChange={(checked) => setDeviceCategory(checked)}
                                                        />
                                                    </Grid>
                                                }
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                {
                                    currentDeviceModel?.cariq &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['feature_tab_cariq']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-cariq"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeCariq}
                                                                onChange={(checked) => {
                                                                    setActiveCariq(checked)
                                                                    if (!checked) setCariq(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeCariq &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-cariq-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={cariq}
                                                                onChange={(checked) => setCariq(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    currentDeviceModel?.carbEnable &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['feature_tab_carb']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-carb"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeCarb}
                                                                onChange={(checked) => {
                                                                    setActiveCarb(checked)
                                                                    if (!checked) setCarb(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeCarb &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-carb-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                                checked={carb}
                                                                onChange={(checked) => setCarb(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    (isVidfleet || isSmartWitness) &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_linked_mode']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-linked-mode"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeLinkedMode}
                                                                onChange={(checked) => {
                                                                    setActiveLinkedMode(checked)
                                                                    if (!checked) setLinkedMode(false);
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeLinkedMode &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-linked-mode-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_actions_linked_mode_pair'], messages['devices_bulk_actions_linked_mode_camera']]}
                                                                checked={linkedMode}
                                                                onChange={(checked) => setLinkedMode(checked)}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    (isVidfleet || isSmartWitness) && HasPermission(user, "untlm", "u") &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15, height: 47 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_main_live_mode']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-live-mode"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeLiveMode}
                                                                onChange={(checked) => {
                                                                    setActiveLiveMode(checked)
                                                                    if (!checked) setLiveMode("Streaming");
                                                                }}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeLiveMode &&
                                                        <Grid item xs={4} style={{ marginTop: 10 }}>
                                                            <ToggleSwitch
                                                                id="toogle-live-mode-value"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_main_live_mode_straming'], messages['devices_main_live_mode_photo']]}
                                                                checked={liveMode === "Streaming"}
                                                                onChange={(checked) => setLiveMode(checked ? "Streaming" : "Photo")}
                                                            />
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                {
                                    false && !isVidfleet && !isSmartWitness &&
                                    <Grid item xs={12}>
                                        <Card>
                                            <CardContent>
                                                <Grid container style={{ width: '100%', display: 'flex', marginTop: 15 }}>
                                                    <Grid item xs={5}>
                                                        <div>
                                                            <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_send_command']}</label>
                                                            <ToggleSwitch
                                                                id="toogle-send-command"
                                                                large
                                                                blueToggle
                                                                optionLabels={[messages['devices_bulk_active'], messages['devices_bulk_inactive']]}
                                                                checked={activeSendCommand}
                                                                onChange={(checked) => setActiveSendCommand(checked)}
                                                            />
                                                        </div>
                                                    </Grid>
                                                    {
                                                        activeSendCommand &&
                                                        <Grid item xs={12} style={{ marginTop: 10/* , marginBottom: 50 */ }}>
                                                            <Grid container>
                                                                <Grid item xs={12}>
                                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                        <label className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1" style={{ marginRight: 5 }}>{messages['devices_bulk_send_command_via']}</label>
                                                                        <RadioButton
                                                                            onChange={() => {
                                                                                setSendCommandBy('SMS')
                                                                                setCommandSelections({})
                                                                            }}
                                                                            value={sendCommandBy === 'SMS'}
                                                                            label={messages['devices_bulk_actions_sms']}
                                                                            position="end"
                                                                        />
                                                                        <RadioButton
                                                                            onChange={() => {
                                                                                setSendCommandBy('OTA')
                                                                                setCommandSelections({})
                                                                            }}
                                                                            value={sendCommandBy === 'OTA'}
                                                                            label={messages['devices_bulk_actions_ota']}
                                                                            position="end"
                                                                        />
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <div style={{ display: 'grid' }}>
                                                                        <label className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1" style={{ marginRight: 5, marginBottom: 10 }}>{messages['devices_bulk_actions_open_command']}</label>
                                                                        <ToggleSwitch
                                                                            id="toogle-open-command"
                                                                            large
                                                                            blueToggle
                                                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                                                            checked={openCommand}
                                                                            onChange={(checked) => {
                                                                                setOpenCommand(checked)
                                                                                if (!checked) setRawCommand("");
                                                                                if (checked) setCommandSelections({});
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    {
                                                                        !openCommand &&
                                                                        <div style={{ marginTop: 10, marginBottom: 150 }}>
                                                                            <div className="command-counters-wrapper">
                                                                                {
                                                                                    deviceCounters.unitTypes.map((unitType) => (
                                                                                        <div className="command-counter" key={`counter-ut-${unitType.id}`}>
                                                                                            <strong>{messages['devices_bulk_unit_type']}:</strong> {unitType.name} ({unitType.count})
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                                {
                                                                                    deviceCounters.deviceModels.map((deviceModelCounter) => (
                                                                                        <div className="command-counter" key={`counter-dm-${deviceModelCounter.id}`}>
                                                                                            <strong>{messages['devices_bulk_actions_device_model']}:</strong> {deviceModelCounter.name} ({deviceModelCounter.count})
                                                                                        </div>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                            {
                                                                                commandGroups.map((group) => (
                                                                                    <div className="group-command-selector" key={group.key}>
                                                                                        <label className="group-command-label">
                                                                                            {messages['devices_bulk_command_entity_label'].replace('{entity}', group.entity).replace('{name}', group.entityLabel || group.entity)}
                                                                                        </label>
                                                                                        <span className="group-command-count">
                                                                                            {messages['devices_bulk_devices_count'].replace('{count}', group.deviceCount)}
                                                                                        </span>
                                                                                        <Select
                                                                                            id={`command-list-${group.key}`}
                                                                                            value={commandSelections[group.key] || null}
                                                                                            valueField="id"
                                                                                            textField="label"
                                                                                            options={group.cannedCommands || []}
                                                                                            placeholder={messages['devices_bulk_actions_command']}
                                                                                            onChange={(value) => setCommandSelections(prev => ({ ...prev, [group.key]: value }))}
                                                                                            loading={commandsLoading}
                                                                                            required
                                                                                            requiredMessage={messages['required_field']}
                                                                                        />
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                            {
                                                                                !commandsLoading && commandGroups.length === 0 &&
                                                                                <div className="group-command-empty">{messages['devices_bulk_no_commands_available']}</div>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {
                                                                        openCommand &&
                                                                        <div style={{ marginTop: 10, marginBottom: 150 }} className="raw-command-container">
                                                                            <Input
                                                                                label={messages['devices_bulk_actions_raw_command']}
                                                                                value={rawCommand}
                                                                                type="textarea"
                                                                                style={{ width: '100%', height: 500 }}
                                                                                onChange={(value) => setRawCommand(value)}
                                                                                required
                                                                                requiredMessage={messages['required_field']}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                }
                                <Grid item xs={12}>
                                    <Card>
                                        <CardContent>
                                            <Grid container style={{ width: '100%', display: 'flex', marginTop: 15 }}>
                                                <Grid item xs={5}>
                                                    <div>
                                                        <label style={{ marginBottom: 5 }}>{messages['devices_bulk_actions_tags']}</label>
                                                        <ToggleSwitch
                                                            id="toogle-tags"
                                                            large
                                                            blueToggle
                                                            optionLabels={[messages['devices_bulk_enabled'], messages['devices_bulk_disabled']]}
                                                            checked={activeTags}
                                                            onChange={(checked) => {
                                                                setActiveTags(checked)
                                                                if (!checked) setActiveTags(false)
                                                            }}
                                                        />
                                                    </div>
                                                </Grid>
                                                {
                                                    activeTags &&
                                                    <Grid item xs={7} style={{ marginTop: 10 }}>
                                                        <Select
                                                            id="tags-selector"
                                                            label={messages['accounts_main_tags']}
                                                            value={selectedTags?.length ? tags.filter((item) => selectedTags.find(x => x === item.id)) : []}
                                                            onChange={(values = []) => {
                                                                setSelectedTags(values?.map(x => x.id) || [])
                                                            }}
                                                            options={tags}
                                                            textField="label"
                                                            valueField="id"
                                                            loading={loadingTags}
                                                            isClearable
                                                            placeholder={messages['select']}
                                                            multiple
                                                            menuPlacement="top"
                                                        />
                                                    </Grid>
                                                }
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Form>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
                {
                    ((step === 2 && !bulkFeatures) || step === 3) &&
                    <Button
                        style={{ backgroundColor: '#e4e4e4' }}
                        className="btn-cancel"
                        onClick={() => {
                            if (step === 2 && !bulkFeatures) {
                                setDeviceModel(null);
                                setManufacturer(null);
                                setSimProvider(null);
                                setSelectedItems([]);
                                tableRef.current?.setSelectedItems([]);

                            }
                            if (step === 3 && !bulkFeatures) {
                                resetFeatures();
                            }
                            setStep(step - 1)
                        }}
                    >
                        {messages['common_back']}
                    </Button>
                }
                <Button
                    className="btn-dark-blue"
                    onClick={() => step === 3 ? formRef?.current?.submit() : handleSteps()}
                >
                    {step === 3 ? messages['devices_bulk_apply_changes'] : messages['common_next']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default BulkActions;